import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarDropdownButton_vue_vue_type_script_setup_true_lang_default from "./ScalarDropdownButton.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                         */
//#region src/components/ScalarDropdown/ScalarDropdownButton.vue
var ScalarDropdownButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarDropdownButton_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-128eed00"]]);
//#endregion
export { ScalarDropdownButton_default as default };

//# sourceMappingURL=ScalarDropdownButton.vue.js.map